<template>
  <div class="gallery" v-if="galleries.length">
    <div class="point" style="left:350px; top: 970px;" @click="openGallery(galleries[0].cod_galeria)">
        <img src="../assets/mascote_mapa.png" alt="">
        <p>{{galleries[0].nome}}</p>
    </div>
    <div class="point" style="left:120px; top: 725px;" @click="openGallery(galleries[1].cod_galeria)">
        <img src="../assets/mascote_mapa.png" alt="">
        <p>{{galleries[1].nome}}</p>
    </div>
    <div class="point" style="left:870px; top: 875px;" @click="openGallery(galleries[2].cod_galeria)">
        <img src="../assets/mascote_mapa.png" alt="">
        <p>{{galleries[2].nome}}</p>
    </div>
    <!-- <div class="point" style="left:870px; top: 890px;">
        <img src="../assets/mascote_mapa.png" alt="">
    </div>
    <div class="point" style="left:770px; top: 760px;">
        <img src="../assets/mascote_mapa.png" alt="">
    </div>
    <div class="point" style="left:1130px; top: 680px;">
        <img src="../assets/mascote_mapa.png" alt="">
    </div> -->

    <GalleryList 
    :key="galleries[0].cod_galeria" 
    :gallery="galleries[0]"
    :activeGallery.sync="activeGallery"
    v-if="activeGallery == galleries[0].cod_galeria"
    />

    <GalleryList 
    :key="galleries[1].cod_galeria" 
    :gallery="galleries[1]"
    :activeGallery.sync="activeGallery"
    v-if="activeGallery == galleries[1].cod_galeria"
    />

    <GalleryList 
    :key="galleries[2].cod_galeria" 
    :gallery="galleries[2]"
    :activeGallery.sync="activeGallery"
    v-if="activeGallery == galleries[2].cod_galeria"
    />
  </div>
</template>

<script>
import axios from 'axios'
import GalleryList from '@/components/GalleryList'

export default {
  name: 'gallery',
  components: {
    GalleryList
  },
  data() {
      return {
        galleries: [],
        activeGallery: null
      }
  },
  mounted() {
    let vm = this;
    axios
    .get('https://www.stillos.com.br/galerias/index.php?contrato=3998')
    .then((response) => {
        vm.galleries = response.data
    })
  },
  methods: {
      openGallery(id){
          this.activeGallery = id
      }
  },
}
</script>


<style scoped lang="scss">
.gallery{
  width: 1920px;
  height: 1080px;
  background-image: url('../assets/mapa.png');
  background-size: cover;
  background-position: -100px;
  .point {  
    width: 80px;
    height: 80px;
    position: absolute;
    border-radius: 50%;
    text-align: center;
    font-size: 28px;
    &:hover {
        img{
            opacity: 1;
        }
    }
    p {
        width: max-content;
        font-weight: bold;
        text-transform: uppercase;
        color: #fff;
        text-shadow: 6px 3px 11px #000;
        background: #00000087;
        padding: 0 15px;
        border-radius: 15px;
        position: absolute;
        top: 20px;
        left: 90px;
        transition: 200ms;
    }
    img{
        width: 180px;
        position: absolute;
        left: -70px;
        top: -190px;
        opacity: 0;
        transition: 200ms;
        cursor: pointer;
    }
  }
}
</style>